const locationsManagementColumns = {
  analysisCode: {
    key: 'name',
    label: 'name',
    type: 'text',
  },
  customerName: {
    key: 'description',
    label: 'description',
    type: 'text',
  },
  code: {
    key: 'code',
    label: 'code',
    type: 'text',
  },
  emails: {
    key: 'locationEmails',
    label: 'emails',
    type: 'function',
    get: (value) => (value ? value.map((le) => le.email).join(', ') : ''),
    minWidth: 200,
  },
  enabled: {
    label: 'enabled',
    type: 'boolean',
    minWidth: 40,
    sortable: false,
    align: 'center',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    buttons: [
      {
        name: 'editLocation',
        icon: 'fas fa-pencil',
        permissions: ['locationsManage'],
      },
      {
        name: 'disableLocation',
        icon: 'fas fa-user-alt-slash',
        permissions: ['locationsManage'],
        showCondition: (row) => row.enabled,
      },
    ],
  },
};

export default locationsManagementColumns;
